import {
    push
} from 'connected-react-router';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import ComposerMediaPreview, {
    PropsFromDispatch,
    PropsFromState,
} from '../components/ComposerMediaPreview';
import {
    RootState,
    selectMediaStore,
} from '../store';
import {
    addPhotoToPost
} from '../store/composer/actions';

export const mapStateToProps = (
    state: RootState
): PropsFromState => ({
    mediaStore: selectMediaStore(state)
});

export const mapDispatchToProps = (
    dispatch: Dispatch
): PropsFromDispatch => ({
    addMediaToPost: (mediaURL: string) => dispatch(addPhotoToPost(mediaURL))
});

export default connect(mapStateToProps, mapDispatchToProps)
    (ComposerMediaPreview);
